import React, { Fragment, useEffect, useState } from "react";
import { Dropdown, Menu, Badge, Popover, Collapse } from "antd";
import APIService from "../services/APIService";
import { selectCountCart, setModalCart } from "../app/features/cart";
import { useSelector, useDispatch } from "react-redux";
import {
  CaretDownOutlined,
  QuestionCircleOutlined,
  PhoneOutlined,
  SearchOutlined,
  UserOutlined,
  HeartOutlined,
  ShoppingCartOutlined,
  TagFilled,
  InfoCircleFilled,
  StarFilled,
  InsertRowBelowOutlined,
  InsertRowRightOutlined,
} from "@ant-design/icons";
import Icon from "@ant-design/icons";
import { images } from "../assets";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  selectToken,
  clearAuthen,
  selectUsername,
  selectTypeUser,
  selectAuthen,
} from "../app/features/authen";
import SearchBar from "./SearchBar";
import TopBanner from "../components/home/TopBanner";
import { saveCookies } from "../utils";
const { Panel } = Collapse;
const renderJoin = (
  <div className="flex items-center justify-center py-[11px] text-xs font-semibold text-white bg-main-blue">
    Tham gia ngay để trở thành thành viên hệ thống trao đổi mua bán Thuốc -
    Sphacy
    <Link
      to="/signup"
      className="px-3 py-1 bg-white text-black rounded-2xl	ml-1.5 font-bold"
    >
      Tham gia
    </Link>
  </div>
);

const menu = (
  <Menu
    items={
      [
        // {
        //   key: "1",
        //   label: (
        //     <a target="_blank" rel="noopener noreferrer" href="">
        //       ENG
        //     </a>
        //   ),
        // },
      ]
    }
  />
);

const renderSupport = (
  <div className="flex justify-center flex-1 bg-gray px-4">
    <div class="flex flex-row  justify-between items-center py-2.5 w-content">
      <div className="flex justify-between gap-x-3">
        <div className="w-6 h-4">
          <img src={images.covn} alt="" />
        </div>
        <span>VN</span>
        {/* <Dropdown overlay={menu}>
          <a
            className="flex flex-row items-center"
            href=""
            onClick={(e) => e.preventDefault()}
          >
            VN
            {/* <CaretDownOutlined className="ml-2" /> */}
          {/* </a> */}
        {/* </Dropdown> */ }
      </div>
      <div class="flex flex-row">
        <Link to="/contact">
          <div className="flex flex-row items-center text-xs">
            <PhoneOutlined className="mr-2 text-main-blue" /> Liên hệ chúng tôi
          </div>
        </Link>
        <Link to="/support">
          <div className="flex flex-row items-center ml-12 text-xs">
            <QuestionCircleOutlined className="mr-2 text-main-blue" /> Hỗ trợ
          </div>
        </Link>
      </div>
    </div>
  </div>
);

export default function Header() {
  const location = useLocation();
  const [listCategory, setListCategory] = useState(["", "", "", "", ""]);
  const [banner, setBanner] = useState({});
  const [hoverProduct, setHoverProduct] = useState(false);
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const userName = useSelector(selectUsername);
  const typeUser = useSelector(selectTypeUser);
  const countCart = useSelector(selectCountCart);
  const authen = useSelector(selectAuthen);
  const navigate = useNavigate();
  const onOpen = () => {
    if (token) {
      dispatch(setModalCart(true));
    } else {
      navigate("/signin");
    }
  };
  const menuInfo = (
    <Menu
      items={[
        {
          key: "1",
          label: token ? (
            <button
              onClick={async () => {
                const objAuthen = {
                  drug_store: authen.drug_store,
                  token: authen.token,
                  userinfo: authen.userinfo,
                };
                await saveCookies(JSON.stringify(objAuthen));
                window.open(
                  `${
                    typeUser == "GDP"
                      ? "https://gdp.sphacy.vn/"
                      : "https://gpp.sphacy.vn/"
                  }`,
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
              target={`_blank`}
              class=" py-3 px-0  flex justify-center menu w-full  text-sm font-extrabold"
            >
              HỆ THỐNG QUẢN LÝ
            </button>
          ) : (
            ""
          ),
        },
        {
          key: "2",
          label: token ? (
            <button
              onClick={() => {
                dispatch(clearAuthen());
              }}
              target={token && `_blank`}
              class=" py-3 px-0  flex justify-center menu w-full text-sm font-extrabold"
            >
              ĐĂNG XUẤT
            </button>
          ) : (
            ""
          ),
        },
      ]}
    />
  );

  const renderRowMenu = (row, index) => {
    if (row.children) {
      return (
        <Collapse
          key={index}
          bordered={false}
          expandIconPosition="end"
          className="site-collapse-custom-collapse"
        >
          <Panel
            header={row.name}
            key="1"
            className="text-[#222222] site-collapse-custom-panel"
          >
            {row.children.map((item, index) => (
              <p key={index} className="py-3 text-left-menu">
                {item.name}
              </p>
            ))}
          </Panel>
        </Collapse>
      );
    } else {
      return (
        <Link
          to={`/category?cateId=${row.id}`}
          onClick={() => setHoverProduct(false)}
        >
          <p className="px-3 py-2 hover:bg-[#ffffff] hover:text-[#119AE2] text-[#222222] font-normal hover:font-extrabold">
            {row.name}
          </p>
        </Link>
      );
    }
  };
  async function getListCategory() {
    const RESULT = await APIService.getListCategory();
    if (RESULT) {
      setListCategory(RESULT);
    }
  }

  useEffect(() => {
    getListCategory();
  }, []);
  async function getListBanner(from) {
    const RESULT = await APIService.getListBanner(from);
    if (RESULT) {
      setBanner(RESULT);
    }
  }
  useEffect(() => {
    getListBanner("according-drug");
  }, []);
  const content = (
    <div className="flex flex-row w-content h-[405px] ">
      <div className="p-2 rounded-[10px] w-[250px] overflow-scroll">
        {listCategory.map((item, index) => renderRowMenu(item, index))}
      </div>
      <div className="flex flex-1 p-3 bg-white">
        <TopBanner data={banner.above} />
      </div>
    </div>
  );
  const dropContent = (
    <a
      className="flex items-center "
      href=""
      onClick={(e) => e.preventDefault()}
    >
      {userName ? (
        <div className="font-bold text-[#119AE2] text-xs mr-2 flex flex-col items-end">
          <p>Hi,</p>
          {userName}
        </div>
      ) : null}

      {!token ? (
        <Link to="/signin">
          <div className="w-[36px] h-[36px] border border-solid border-blue-600 rounded-full flex items-center">
            <UserOutlined style={{ width: "35px" }} />
          </div>
        </Link>
      ) : (
        <div className="w-[36px] h-[36px] border border-solid border-blue-600 rounded-full flex items-center">
          <UserOutlined style={{ width: "35px" }} />
        </div>
      )}
    </a>
  );
  const DaiLySvg = () => (
    <svg
      width="15"
      height="18"
      viewBox="0 0 15 18"
      // fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 18H15V5.60656V0H0V18ZM8.40517 2.16394H12.8017V4.91803H8.40517V2.16394ZM8.40517 7.67213H12.8017V10.4262H8.40517V7.67213ZM8.40517 13.1803H12.8017V15.9344H8.40517V13.1803ZM2.32759 2.16394H6.59483V4.91803H2.19827V2.16394H2.32759ZM2.32759 7.67213H6.59483V10.4262H2.19827V7.67213H2.32759ZM2.32759 13.1803H6.59483V15.9344H2.19827V13.1803H2.32759Z"
        // fill="none"
      />
    </svg>
  );
  return (
    <div className="flex flex-col hidden md:block">
      {!token && renderJoin}
      {renderSupport}
      <div className="flex justify-center flex-1 px-4 my-5">
        <div class="flex flex-row  justify-between items-center py-2.5 w-content">
          <Link to="/" className="flex items-center">
            <div className="bg-white w-[74px] h-[74px] p-3 border-2 border-main-blue rounded-full">
              <img alt="logo" src={images.logo} />
            </div>
            <img
              alt="branch"
              src={images.branch}
              className="h-[28px] ml-[30px]"
            />
          </Link>
          <div className="flex flex-1 mx-12">
            <SearchBar />
          </div>

          <div className="flex items-center">
            {token ? (
              <Dropdown
                overlayClassName="dropHeader"
                overlayStyle={{ width: "300px", borderRadius: "100px" }}
                overlay={menuInfo}
                placement="bottomRight"
              >
                {dropContent}
              </Dropdown>
            ) : (
              <Link>{dropContent}</Link>
            )}
          </div>
          <Badge count={countCart} color="#119AE2">
            <button
              className="bg-gray  w-[36px] h-[36px] p-3 rounded-full flex justify-center ml-7"
              onClick={onOpen}
            >
              <ShoppingCartOutlined />
            </button>
          </Badge>
        </div>
      </div>
      <div className="w-full bg-[#EBEBEB] h-[1px]" />
      <div className="flex justify-center flex-1 px-4">
        <div class="flex flex-row  justify-between items-center py-2.5 w-content">
          <div className="flex justify-between gap-x-3">
            <Popover
              trigger="hover"
              content={content}
              overlayInnerStyle={{ borderRadius: 12, overflow: "hidden" }}
              open={hoverProduct}
              onOpenChange={(value) => setHoverProduct(value)}
              color="#e7f5fd"
              placement="bottomLeft"
            >
              <div
                className={`flex p-1 px-2 rounded-md items-center text-base text-[#222222] icon-tag ${
                  hoverProduct && `text-white bg-main-blue`
                }`}
              >
                <TagFilled
                  className={`mr-2   ${
                    hoverProduct ? `text-white bg-main-blue` : `text-main-blue`
                  }`}
                />{" "}
                Sản phẩm
              </div>
            </Popover>
            <Link
              to="/agency"
              className={`buttonAgency flex items-center icon-tag p-1 px-2 ml-6 text-base text-[#222222]  rounded-md hover:bg-main-blue hover:text-white ${
                location.pathname === "/agency"
                  ? " bg-main-blue text-white"
                  : ""
              }`}
            >
              <Icon
                component={DaiLySvg}
                className={`childIcon mr-2  hover:fill-white ${
                  location.pathname === "/agency"
                    ? "fill-white"
                    : "fill-main-blue"
                }`}
              />
              Đại lý
            </Link>
          </div>

          <div className="w-[160px] h-[30px] bg-5-star-service flex justify-around font-semibold text-base text-white	 items-center">
            <StarFilled className="text-yellow-300" /> Dịch Vụ 5 Sao
          </div>
        </div>
      </div>
    </div>
  );
}
//flex items-center ml-6 text-base
